import React, { useCallback, useRef, useState } from 'react';
import { CardScrollDiv, ScrollContainer } from '../Product/PdpCombo/styled';
import {
  LeftController,
  RightController,
} from '../StoreHomePage/BestSeller/styled';
import { HiddenOverflow } from './styled';

export default function AnywhereHorizontalScroll(props) {
  const {
    firstElementId,
    lastElementId,
    leftArrow,
    rightArrow,
    bogo,
    scrolledWidth,
    autoHeight,
    nomWebScroll,
    showMobileArrows,
    allReviews,
    babyTrustUI,
    shiftArrow,
    isForNewCdPage,
  } = props;
  const [leftArrowbtn, setLeftArrowbtn] = useState(false);
  const [rightArrowbtn, setRightArrowbtn] = useState(false);
  const [containerRect, setContainerRect] = useState(null);
  const firstRender = useRef(true);
  const scrollDivRef = useRef(null);
  const scrollTimeout = useRef(null);
  const hideArrows = useRef(null);
  const productCardRef = useCallback(
    (elem) => {
      if (elem != null) {
        scrollDivRef.current = elem;
        setContainerRect(elem.getBoundingClientRect());
        if (elem.scrollWidth === elem.clientWidth) {
          hideArrows.current = true;
        }
        if (elem.scrollWidth > elem.clientWidth && firstRender.current) {
          firstRender.current = false;
          setRightArrowbtn(true);
        }
      }
    },
    [leftArrowbtn, rightArrowbtn],
  );
  const isElementInViewport = (el) => {
    const rect = el.getBoundingClientRect();

    return [
      rect.top >= containerRect.top &&
        rect.left >= containerRect.left &&
        rect.bottom <= containerRect.bottom &&
        rect.right <= containerRect.right,
      rect.right - containerRect.right,
      containerRect.left - rect.left,
    ];
  };

  const arrowStateHandler = () => {
    const firstElement = document.getElementById(firstElementId);
    const lastElement = document.getElementById(lastElementId);
    if (firstElement && lastElement) {
      const [firstVisible] = isElementInViewport(firstElement);
      const [lastVisible] = isElementInViewport(lastElement);
      if (firstVisible) {
        setLeftArrowbtn(false);
        setRightArrowbtn(true);
      } else if (lastVisible) {
        setLeftArrowbtn(true);
        setRightArrowbtn(false);
      } else {
        setLeftArrowbtn(true);
        setRightArrowbtn(true);
      }
    }
  };

  const arrowsInViewChecker = (e) => {
    if (!hideArrows.current) {
      clearTimeout(scrollTimeout.current);
      scrollTimeout.current = setTimeout(() => {
        arrowStateHandler();
      });
    }
  };

  const arrowHandler = (direc) => {
    const firstElement = document.getElementById(firstElementId);
    const lastElement = document.getElementById(lastElementId);
    const [firstVisible, firstOffsetRight, firstOffsetLeft] =
      isElementInViewport(firstElement);
    const [lastVisible, lastOffsetRight, lastOffsetLeft] =
      isElementInViewport(lastElement);
    if (direc == 'left') {
      if (firstVisible) {
      } else {
        firstOffsetLeft > scrolledWidth / 2
          ? (scrollDivRef.current.scrollLeft -= scrolledWidth)
          : (scrollDivRef.current.scrollLeft -= firstOffsetLeft + 10);
      }
    } else {
      if (lastVisible) {
      } else {
        lastOffsetRight > scrolledWidth / 2
          ? (scrollDivRef.current.scrollLeft += scrolledWidth)
          : (scrollDivRef.current.scrollLeft += lastOffsetRight + 10);
      }
    }
    setTimeout(() => arrowStateHandler(), 500);
  };

  return (
    <HiddenOverflow>
      <CardScrollDiv
        onScroll={(e) => arrowsInViewChecker(e)}
        ref={productCardRef}
        id="checkscroll"
      >
        {leftArrowbtn ? (
          <LeftController
            bogo={bogo}
            onClick={() => arrowHandler('left')}
            autoHeight={autoHeight}
            showMobileArrows={showMobileArrows}
            allReviews={allReviews}
            babyTrustUI={babyTrustUI}
            shiftArrow={shiftArrow}
          >
            {leftArrow}
          </LeftController>
        ) : null}
        {rightArrowbtn ? (
          <RightController
            bogo={bogo}
            onClick={() => arrowHandler('right')}
            autoHeight={autoHeight}
            showMobileArrows={showMobileArrows}
            allReviews={allReviews}
            babyTrustUI={babyTrustUI}
            shiftArrow={shiftArrow}
          >
            {rightArrow}
          </RightController>
        ) : null}
        <ScrollContainer
          allReviews={allReviews}
          nomWebScroll={nomWebScroll}
          isForNewCdPage={isForNewCdPage}
        >
          {props.children}
        </ScrollContainer>
      </CardScrollDiv>
    </HiddenOverflow>
  );
}
